import DOMPurify from "dompurify";
import isEmptyHtmlContent from "notes-and-forms-v2/util/isEmptyHtmlContent";
import {
  ElementViewForClipboardProps,
  ElementViewProps,
} from "../AtomicElementView";
import styles from "./TextOnlyContent.module.scss";

export function TextOnlyContentForClipboard({
  element,
}: ElementViewForClipboardProps<TextOnlyElement>) {
  return <div dangerouslySetInnerHTML={{ __html: element.description }} />;
}

export default function TextOnlyContent({
  element,
}: ElementViewProps<TextOnlyElement>) {
  const sanitizedHtmlContent = DOMPurify.sanitize(element.description);
  const isEmpty = isEmptyHtmlContent(sanitizedHtmlContent);

  if (isEmpty) {
    return null;
  }

  return (
    <div
      className={styles.htmlContent}
      dangerouslySetInnerHTML={{ __html: sanitizedHtmlContent }}
    />
  );
}
